var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankDomrf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#384249",
    d: "M14.35 35.3H3.22v-4.7h11.1v4.7h.03Zm2.24-7.07H1V40h2.22v-2.36h13.32v-9.41h.05ZM3.22 7.07l4.45-4.7v16.47H3.22V7.07ZM1 21.18h8.87V0h-3.3L1 5.89v15.3ZM14.35 2.36h4.46v16.48h-4.46V2.36Zm-2.22 18.82H21V0h-8.87v21.18Zm24.41 0h2.22V0H35.4v.02l-3.35 3.53V0H28.7l-5.52 5.89v15.3h2.22V7.06l4.46-4.7v18.81h2.21V7.07l4.46-4.7v18.81ZM1 25.88h37.78v-2.36H1v2.37Zm28.9 4.71h6.64v4.7H29.9v-4.7Zm-2.23 4.7H21v-4.7h6.67v4.7Zm2.22 2.35h8.9v-9.41H18.8v9.4h8.86V40h2.22v-2.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankDomrf);
export default ForwardRef;